import React, { Component } from "react";
import Subscribe from "../../common/Subscribe";


class Newsletter extends Component{
    render(){
        return(
            <div className="newsletter-area appshowcase-newsletter pb--120">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="section-title text-center mb--55">
                                <h3 className="heading fontWeight600">Subscribe to receive updates</h3>
                            </div>
                            <div className="inner">
                                <div className="newsletter-form--1">
                                    <Subscribe />
                                </div>
                                <h6 className="next-arrowland title text-center">What’s next in AeroLand?  <a className="link-hover" href="/branding">Learn more</a></h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default Newsletter;
